import useSWR from "swr";
import get from "lodash/get";
import map from "lodash/map";
import filter from "lodash/filter";
import startsWith from "lodash/startsWith";
import isEmpty from "lodash/isEmpty";
import Link from "next/link";

import styles from "./Menu.module.scss";

import Image from "grandus-lib/components-atomic/image/Image";

import { CATEGORY_MICE, HEADER_MENU_CATGEORY } from "constants/CustomConstants";
import { useRouter } from "next/router";

const Menu = () => {
  const router = useRouter();
  const { data, error } = useSWR("/api/lib/v1/categories", (url) =>
    fetch(url).then((r) => r.json())
  );

  const categories = filter(
    data,
    (category) => category?.hash !== HEADER_MENU_CATGEORY
  );

  const isCategory = startsWith(router?.route, "/kategoria/");

  return (
    <nav id={styles.navigation}>
      <div className="container">
        <ul>
          {isEmpty(categories) ? (
            <li style={{ height: "70px" }}>&nbsp;</li>
          ) : (
            map(categories, (item, index) => {
              if (get(item, "hash") == CATEGORY_MICE) {
                return "";
              }
              const coverPhoto = get(item, "coverPhoto");
              return (
                <li
                  key={`navigation-item-${get(item, "id")}-${index}`}
                  className={isCategory ? styles?.inCategory : ""}
                >
                  <Link
                    href="/kategoria/[category]/[[...parameters]]"
                    as={`/kategoria/${get(item, "urlName")}`}
                    scroll={true}
                  >
                    <a
                      className={`${
                        styles["item-" + get(item, "hash", "default")]
                      } ${!coverPhoto ? styles?.categoryFallback : ""}`}
                    >
                      {coverPhoto ? (
                        <Image
                          photo={coverPhoto}
                          size={"210x130__cropped"}
                          type={"png"}
                          useNextImage={true}
                          imageProps={{
                            priority: true,
                          }}
                        />
                      ) : (
                        ""
                      )}
                      {!coverPhoto && get(item, "mainPhoto") ? (
                        <Image
                          photo={get(item, "mainPhoto")}
                          size={"32x32"}
                          type={"png"}
                        />
                      ) : (
                        ""
                      )}
                      <span>{get(item, "name")}</span>
                    </a>
                  </Link>
                </li>
              );
            })
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Menu;
